import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft, FaTag } from "react-icons/fa";
import { getCurrentUser } from "./session";
import "./PostOffer.css";

export default function PostOffer() {
  const navigate = useNavigate();
const [submitting, setSubmitting] = useState(false);
const [message, setMessage] = useState("");
const [error, setError] = useState("");
const handleSubmit = async (event) => {
  event.preventDefault();
const formElement = event.currentTarget;
  setMessage("");
  setError("");

  const user = getCurrentUser();

  if (!user?.token) {
    setError("Please sign in before posting an offer.");
    return;
  }

  const form = new FormData(event.currentTarget);

  /*
   * Image upload will be connected next.
   * Do not silently ignore a selected image.
   */
  const image = form.get("image");

const hasImage =
  image instanceof File &&
  image.size > 0;

if (hasImage) {
  const allowedTypes = [
    "image/jpeg",
    "image/png",
    "image/webp",
  ];

  if (!allowedTypes.includes(image.type)) {
    setError(
      "Offer image must be JPG, PNG, or WEBP."
    );
    return;
  }

  if (image.size > 2 * 1024 * 1024) {
    setError(
      "Offer image must be 2 MB or smaller."
    );
    return;
  }
}

const API_BASE = (
  process.env.REACT_APP_GOOURHUB_BUSINESS_API ||
  "https://business-api.goourhub.com"
).replace(/\/+$/, "");

  const payload = {
    business_name: String(
      form.get("business_name") || ""
    ).trim(),

    title: String(
      form.get("title") || ""
    ).trim(),

    short_description: String(
      form.get("short_description") || ""
    ).trim(),

    offer_text: String(
      form.get("offer_text") || ""
    ).trim(),

    promo_phrase: String(
      form.get("promo_phrase") || ""
    ).trim(),

    start_date: String(
      form.get("start_date") || ""
    ),

    end_date: String(
      form.get("end_date") || ""
    ),

    image_url: "",

    conditions: String(
      form.get("conditions") || ""
    ).trim(),
  };

  try {
    setSubmitting(true);

    const response = await fetch(
      "https://business-api.goourhub.com/api/offers",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${user.token}`,
        },
        body: JSON.stringify(payload),
      }
    );

    formElement.reset();

setMessage(
  "Offer submitted successfully. " +
  "It is waiting for GoOurHub approval."
);

 const data = await response
  .json()
  .catch(() => ({}));

if (!response.ok) {
  throw new Error(
    data?.message ||
      "Offer could not be submitted."
  );
}

const offerId =
  data?.offer?.id || "";

let imageUploaded = false;
let imageWarning = "";

if (hasImage) {
  if (!offerId) {
    imageWarning =
      "The offer was submitted, but the image could not be attached because the offer ID was missing.";
  } else {
    try {
      const imageForm =
        new FormData();

      imageForm.append(
        "image",
        image,
        image.name
      );
      
      const imageResponse =
        await fetch(
          `${API_BASE}/api/offers/${encodeURIComponent(
            offerId
          )}/image`,
          {
            method: "POST",

            headers: {
              Accept:
                "application/json",

              Authorization:
                `Bearer ${user.token}`,
            },

            body: imageForm,
          }
        );

      const imageData =
        await imageResponse
          .json()
          .catch(() => ({}));

      if (!imageResponse.ok) {
        throw new Error(
          imageData?.message ||
            "Image upload failed."
        );
      }

      imageUploaded = true;
    } catch (uploadError) {
      imageWarning =
        "Your offer was submitted, but the image could not be uploaded. " +
        `${uploadError.message || "Image upload failed."} ` +
        "Do not submit the offer again.";
    }
  }
}

formElement.reset();

setMessage(
  imageUploaded
    ? "Offer and image submitted successfully. It is waiting for GoOurHub approval."
    : "Offer submitted successfully. It is waiting for GoOurHub approval."
);

if (imageWarning) {
  setError(imageWarning);
}
  } catch (err) {
    setError(
      err?.message ||
      "Offer could not be submitted."
    );
  } finally {
    setSubmitting(false);
  }
};
  return (
    <main className="post-offer-page">
      <div className="post-offer-shell">
        <button
          type="button"
          className="post-offer-back"
          onClick={() => navigate("/hub")}
        >
          <FaArrowLeft />
          Back to Hub
        </button>

        <div className="post-offer-heading">
          <div className="post-offer-icon">
            <FaTag />
          </div>

          <div>
            <span className="post-offer-eyebrow">
              Business promotion
            </span>

            <h1>Post an Offer</h1>

            <p>
              Share a deal with GoOurHub users.
              Offers are reviewed before appearing publicly.
            </p>
          </div>
        </div>

        <form
  className="post-offer-form"
  onSubmit={handleSubmit}
>
  <div className="post-offer-field">
  <label htmlFor="offer-business">
    Business name <span>*</span>
  </label>

  <input
    id="offer-business"
    name="business_name"
    type="text"
    maxLength="150"
    placeholder="Type your business name"
    required
  />

  <small>
    Enter the business name exactly as it appears on GoOurHub.
  </small>


    
  </div>

  <div className="post-offer-field">
    <label htmlFor="offer-title">
      Offer title <span>*</span>
    </label>

    <input
      id="offer-title"
      name="title"
      type="text"
      maxLength="120"
      placeholder="Weekend Family Special"
      required
    />
  </div>

  <div className="post-offer-field">
    <label htmlFor="offer-description">
      Short description <span>*</span>
    </label>

    <textarea
      id="offer-description"
      name="short_description"
      rows="3"
      maxLength="300"
      placeholder="Enjoy a special discount this weekend."
      required
    />
  </div>

  <div className="post-offer-field">
    <label htmlFor="offer-text">
      Discount / offer text <span>*</span>
    </label>

    <input
      id="offer-text"
      name="offer_text"
      type="text"
      maxLength="100"
      placeholder="20% OFF"
      required
    />

    <small>
      Examples: 20% OFF, $10 OFF, Free Consultation
    </small>
  </div>

  <div className="post-offer-field">
    <label htmlFor="promo-phrase">
      Promo code or phrase <span>*</span>
    </label>

    <input
      id="promo-phrase"
      name="promo_phrase"
      type="text"
      maxLength="100"
      placeholder="GOH20 or Mention GoOurHub"
      required
    />

    <small>
      Customers should use this so the business knows they came
      from GoOurHub.
    </small>
  </div>

  <div className="post-offer-dates">
    <div className="post-offer-field">
      <label htmlFor="offer-start">
        Start date <span>*</span>
      </label>

      <input
        id="offer-start"
        name="start_date"
        type="date"
        required
      />
    </div>

    <div className="post-offer-field">
      <label htmlFor="offer-end">
        End date <span>*</span>
      </label>

      <input
        id="offer-end"
        name="end_date"
        type="date"
        required
      />
    </div>
  </div>

  <div className="post-offer-field">
    <label htmlFor="offer-image">
      Offer image <em>Optional</em>
    </label>

<input
  id="offer-image"
  name="image"
  type="file"
  accept="image/jpeg,image/png,image/webp"
/>

<small>
  JPG, PNG, or WEBP. Maximum 2 MB.
</small>
  </div>

  <div className="post-offer-field">
    <label htmlFor="offer-conditions">
      Conditions <em>Optional</em>
    </label>

    <textarea
      id="offer-conditions"
      name="conditions"
      rows="3"
      maxLength="600"
      placeholder="Dine-in only. Cannot be combined with other promotions."
    />
  </div>

  <div className="post-offer-review-note">
    <strong>Offers are reviewed before going live.</strong>
    <span>
      After submission, GoOurHub will review your offer before
      displaying it publicly.
    </span>
  </div>
{error && (
  <div className="post-offer-message post-offer-message--error">
    {error}
  </div>
)}

{message && (
  <div className="post-offer-message post-offer-message--success">
    {message}
  </div>
)}
  <button
  type="submit"
  className="post-offer-submit"
  disabled={submitting}
>
  {submitting
    ? "Submitting..."
    : "Submit Offer for Approval"}
</button>
</form>
      </div>
    </main>
  );
}